import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AdminConfig from './components/AdminConfig';
import MonitoringScreen from './components/MonitoringScreen';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          <Route path="/client-list" element={<AdminConfig />} />
          <Route path="/" element={<MonitoringScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
